import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";

export const downloadOrders = async (params: stdObject) => {
  const {
    t,
    user,
    download,
    setDownload,
    setMsg,
    setModalData,
    setModalData2,
    closeMsg,
    logoutAction,
  } = params;
  setMsg("custom1");
  setModalData({
    code: "loading",
    title: t("p.dontCloseApp"),
    label: t("p.waitUntilProcessIsComplete"),
  });
  const responseDownloadOrders: stdObject = await sendData({
    endPoint: "downloadOrders",
    payload: { serie: user.CODSUC, country: user.PAISUC },
    logoutAction,
  });
  console.log("responseDownloadOrders", responseDownloadOrders);
  const { success, status } = responseDownloadOrders;
  if (success && status) {
    setDownload({ ...download, total: 0 });
    closeMsg();
  } else {
    setMsg("error");
    setModalData2({
      label: t("p.errorDownloadingOrders"),
    });
  }
};
